__turbopack_context__.v({
  "body1": "Typography-module__UiXkmW__body1",
  "body2": "Typography-module__UiXkmW__body2",
  "body3": "Typography-module__UiXkmW__body3",
  "body4": "Typography-module__UiXkmW__body4",
  "button1": "Typography-module__UiXkmW__button1",
  "button2": "Typography-module__UiXkmW__button2",
  "button3": "Typography-module__UiXkmW__button3",
  "buttonLink1": "Typography-module__UiXkmW__buttonLink1",
  "buttonLink2": "Typography-module__UiXkmW__buttonLink2",
  "buttonLink3": "Typography-module__UiXkmW__buttonLink3",
  "caption1": "Typography-module__UiXkmW__caption1",
  "caption2": "Typography-module__UiXkmW__caption2",
  "caption3": "Typography-module__UiXkmW__caption3",
  "caption4": "Typography-module__UiXkmW__caption4",
  "caption5": "Typography-module__UiXkmW__caption5",
  "desktop-display2": "Typography-module__UiXkmW__desktop-display2",
  "desktop-h1": "Typography-module__UiXkmW__desktop-h1",
  "desktop-h2": "Typography-module__UiXkmW__desktop-h2",
  "desktop-h3": "Typography-module__UiXkmW__desktop-h3",
  "desktop-h4": "Typography-module__UiXkmW__desktop-h4",
  "desktop-h5": "Typography-module__UiXkmW__desktop-h5",
  "desktop-h6": "Typography-module__UiXkmW__desktop-h6",
  "display1": "Typography-module__UiXkmW__display1",
  "display2": "Typography-module__UiXkmW__display2",
  "h1": "Typography-module__UiXkmW__h1",
  "h2": "Typography-module__UiXkmW__h2",
  "h3": "Typography-module__UiXkmW__h3",
  "h4": "Typography-module__UiXkmW__h4",
  "h5": "Typography-module__UiXkmW__h5",
  "h6": "Typography-module__UiXkmW__h6",
  "mobile-h1": "Typography-module__UiXkmW__mobile-h1",
  "mobile-h2": "Typography-module__UiXkmW__mobile-h2",
  "mobile-h3": "Typography-module__UiXkmW__mobile-h3",
  "mobile-h4": "Typography-module__UiXkmW__mobile-h4",
  "mobile-h5": "Typography-module__UiXkmW__mobile-h5",
  "mobile-h6": "Typography-module__UiXkmW__mobile-h6",
  "overline1": "Typography-module__UiXkmW__overline1",
  "overline2": "Typography-module__UiXkmW__overline2",
  "subheading1": "Typography-module__UiXkmW__subheading1",
  "subheading2": "Typography-module__UiXkmW__subheading2",
  "subheading3": "Typography-module__UiXkmW__subheading3",
  "subheading4": "Typography-module__UiXkmW__subheading4",
  "textDisplayLg": "Typography-module__UiXkmW__textDisplayLg",
  "textDisplayMd": "Typography-module__UiXkmW__textDisplayMd",
  "textDisplaySm": "Typography-module__UiXkmW__textDisplaySm",
  "textDisplayXl": "Typography-module__UiXkmW__textDisplayXl",
  "textDisplayXs": "Typography-module__UiXkmW__textDisplayXs",
  "textDisplayXxl": "Typography-module__UiXkmW__textDisplayXxl",
  "textLgBold": "Typography-module__UiXkmW__textLgBold",
  "textLgMedium": "Typography-module__UiXkmW__textLgMedium",
  "textLgRegular": "Typography-module__UiXkmW__textLgRegular",
  "textLgSemibold": "Typography-module__UiXkmW__textLgSemibold",
  "textMdBold": "Typography-module__UiXkmW__textMdBold",
  "textMdMedium": "Typography-module__UiXkmW__textMdMedium",
  "textMdRegular": "Typography-module__UiXkmW__textMdRegular",
  "textMdSemibold": "Typography-module__UiXkmW__textMdSemibold",
  "textSmBold": "Typography-module__UiXkmW__textSmBold",
  "textSmMedium": "Typography-module__UiXkmW__textSmMedium",
  "textSmRegular": "Typography-module__UiXkmW__textSmRegular",
  "textSmSemibold": "Typography-module__UiXkmW__textSmSemibold",
  "textXlBold": "Typography-module__UiXkmW__textXlBold",
  "textXlMedium": "Typography-module__UiXkmW__textXlMedium",
  "textXlRegular": "Typography-module__UiXkmW__textXlRegular",
  "textXlSemibold": "Typography-module__UiXkmW__textXlSemibold",
  "textXsBold": "Typography-module__UiXkmW__textXsBold",
  "textXsMedium": "Typography-module__UiXkmW__textXsMedium",
  "textXsRegular": "Typography-module__UiXkmW__textXsRegular",
  "textXsSemibold": "Typography-module__UiXkmW__textXsSemibold",
});
